export const regulatedCompaniesEnum = {
    DX_FCA: 'DX_FCA',
    DX_CNMV: 'DX_CNMV',
    DX_SYC: 'DX_SYC',
    DX_ZERO: 'DX_ZERO',
};
